import React, { Component, useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { createOrder, approveNFT, mintNFT, registerNFT, createAuction, approveSingleAuctionOrder } from '../../../api/nft/nft';
import { connect, useSelector, useDispatch } from 'react-redux';
import { mnemonicValidate } from '@polkadot/util-crypto';
import { Keyring } from '@polkadot/api';
import { getNSTBalanceApi } from '../../../api/wallet/wallet';
import KycStatus from '../../Layouts/KycStatus/KycStatus';
import MissingMnemonics from '../../Layouts/MissingMnemonics/MissingMnemonics';
import ContinueWithPassword from './ContinueWithPassword';
import CryptoJS from 'crypto-js';
import { setCypherSecret } from '../../../actions/auth';
import NotLoggedInRedirection from '../../Auth/NotLoggedInRedirection/NotLoggedInRedirection';
import PageLoader from '../../Layouts/PageLoader/PageLoader';
import PermissionRequired from '../../Layouts/PermissionRequired/PermissionRequired';
import { errorMessageHandler, isVideo } from '../../../utils/utils';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import MnemonicsConfirmationModal from './MnemonicsConfirmationModal';
import NFTStepsModal from './NFTStepsModal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './SingleNFT.css';

const SingleNFT = () => {

    const [data, setData] = useState({

        image: null,
        title: '',
        description: '',
        price: '',
        royalties: 10,
        properties: {
            size: null,
            type: null
        },
        uploadType: null,
        alternativeText: null

    })
    const [showAdvance, setShowAdvance] = useState(false)
    const [imgSrc, setImgSrc] = useState(null)
    const [errors, setErrors] = useState({});
    const [isError, setIsError] = useState("");
    const [loader, setLoader] = useState(null)
    const [messageList, setMessageList] = useState([{
        title: "",
        blockHash: "",
        tokenId: "",
    }])
    const [missMnemonicsModal, setMissMnemonicsModal] = useState(false)
    const [creationStep, setCreationStep] = useState(1)
    const [mnemonicsConfirmationModal, setShowMnemonicsConfirmationModal] = useState(false);
    const [orderHash, setOrderHash] = useState(null)
    const [stepModal, setShowStepModal] = useState(false);
    const [passwordModal, setShowPasswordModal] = useState(false);
    const currentUser = useSelector((state) => state.Profile.profile);
    const balances = useSelector((state) => state.Wallet.balances);
    const cypherSecret = useSelector((state) => state.Auth.cypherSecret);

    const dispatch = useDispatch();

    const onUploadFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // ⚠️ Check if file size > 100MB
        if ((file.size / 1024 / 1024) > 100) {
            alert("File size must be equal or less then 100mb.")
            return;
        }
        const reader = new FileReader();


        reader.onloadend = () => {

            setImgSrc(reader.result); // set preview
            setData(prevState => {
               
                const newState = {
                    ...prevState,
                    image: file,
                    uploadType: file.type
                };
               
                return newState;
            });
        };
        reader.readAsDataURL(file);
    };


    const validateForm = useCallback(() => {
        const newErrors = {};

     

        // 🖼️ Image validation
        if (!data.image) {
            newErrors.image = "Media file is required.";
        }

        // 💲 Price validation
        const priceValue = parseFloat(data.price);
        if (!data.price) {
            newErrors.price = "Price is required and must be a positive number.";
        } else if (Number.isNaN(priceValue) || priceValue <= 0) {
            newErrors.price = "Price must be a positive number greater than zero.";
        }

        // 👑 Royalties validation
        const royaltiesValue = parseInt(data.royalties);
        if (data.royalties === undefined || data.royalties === "") {
            newErrors.royalties = "Royalties are required.";
        } else if (Number.isNaN(royaltiesValue)) {
            newErrors.royalties = "Royalties must be a number.";
        } else if (royaltiesValue < 0 || royaltiesValue > 50) {
            newErrors.royalties =
                "Royalties must be 0%, 10%, 20%, 30%, and maximum 50%.";
        }

        // 🏷️ Title validation
        if (!data.title?.trim()) {
            newErrors.title = "Title is required.";
        }

        // 📝 Description validation
        if (!data.description?.trim()) {
            newErrors.description = "Description is required.";
        }
        // TODO:
      
        if (currentUser.public_address && parseFloat(balances.NUC) <= 0) {
            newErrors.balances = "NUC balance should be greater than 0. Currently, you have 0 balance."
        }

        // ✅ Finalize
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }, [data]);


    let createNft = async () => {

        if (!currentUser.public_address) {
            setMissMnemonicsModal(true)
            return
        }

        if (!validateForm()) {
           
            return;
        }

        if (cypherSecret) {
            setShowPasswordModal(true)
        }
        else {
            setShowMnemonicsConfirmationModal(true)
        }

    };

    const handleMintNft = (mnemonics, publicAddress, saveMyMnemonics, mnemonicsPwd) => {
        if (!mnemonics) {
            setErrors({ mnemonics: "Mnemonics are required." });
            return;
        }

        if (!publicAddress) {
            setErrors({
                public_address:
                    "Your profile address does not match the provided mnemonics. Please use the mnemonics you provided during sign-up.",
            });
            return;
        }

        if (publicAddress.toLowerCase() !== currentUser?.public_address?.toLowerCase()) {
            setErrors({
                public_address:
                    "Your profile address does not match the provided mnemonics. Please use the mnemonics you provided during sign-up.",
            });
            return;
        }
        if (parseFloat(balances.NUC) <= 0) {
            setErrors({
                public_address:
                    "NUC balance should be greater than 0. Currently, you have 0 balance."
            });
        }

        // ✅ All good — process NFT minting

        processNft(mnemonics, saveMyMnemonics, mnemonicsPwd);
    };


    let processNft = async (mnemonics, saveMyMnemonics, mnemonicsPwd) => {
        try {

            if (saveMyMnemonics) {
                const cypher = CryptoJS.AES.encrypt(mnemonics, mnemonicsPwd).toString();
                dispatch(setCypherSecret(cypher));
            }
            const formData = new FormData();
            formData.append('image', data.image);
            formData.append('data', JSON.stringify(data));
            formData.append('secret', mnemonics);
            setLoader(true)
            setErrors({})
            setIsError("")
            setShowStepModal(true)
            setCreationStep(2)
            const response = await registerNFT(formData);
            const { orderId, nftId, blockchainTokenId, blockHash } = response.data.data
            setCreationStep(3)
            let orderHash = null
            try {
                const orderResponse = await createOrder({
                    secret: mnemonics,
                    orderId: orderId,
                    nftId: nftId,
                    blockchainTokenId
                })
                orderHash = orderResponse?.data?.data?.orderHash
            }
            catch (e) {
                console.log("order catch", e)

            }

            setCreationStep(4)
            setLoader(false)
            setOrderHash(orderHash)
            setMessageList([
                {
                    title: "NFT Minted Successfully",
                    blockHash: blockHash
                },
                orderHash ?
                    {
                        title: "NFT order Successfully",
                        blockHash: orderHash
                    } : {},
            ])
        }
        catch (e) {
            setLoader(false)
            setIsError(errorMessageHandler(e))
        }
    }



    const resetState = () => {
        // Reset form data to initial state
        setData({
            image: null,
            title: '',
            description: '',
            price: '',
            royalties: 10,
            properties: {
                size: null,
                type: null
            },
            uploadType: null,
            alternativeText: null
        });

        // Reset UI states
        setShowAdvance(false);
        setImgSrc(null);
        setErrors({});
        setIsError("");
        setLoader(null);

        // Reset modal states
        setShowMnemonicsConfirmationModal(false);
        setShowStepModal(false);

        // Reset creation process
        setCreationStep(0);
        setMessageList([{
            title: "",
            blockHash: "",
            tokenId: "",
        }]);
    };

    useEffect(() => {
        const message = localStorage.getItem("showToast");
        if (message) {
            toast.success(message); // or alert(message)
            localStorage.removeItem("showToast");
        }
    }, []);


    return (

        <main>
            

            <section id="CreateCollectible" className={'py-5'}>
                <div className="container">
                    <div className="row justify-content-center gx-3" id='zIndexMob'>
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-9 col-xxl-9 Fsize_16">
                            <Link to="/create" className="Fsize_16  brandnew">
                                <svg className="mb-1 me-2" viewBox="0 0 14 12" fill="none" width="14" height="14"
                                    xlmns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6.29436 0.292893C6.68488 -0.0976311 7.31805 -0.0976311 7.70857 0.292893C8.0991 0.683417 8.0991 1.31658 7.70857 1.70711L4.41568 5H12.9985C13.5508 5 13.9985 5.44772 13.9985 6C13.9985 6.55228 13.5508 7 12.9985 7H4.41568L7.70857 10.2929C8.0991 10.6834 8.0991 11.3166 7.70857 11.7071C7.31805 12.0976 6.68488 12.0976 6.29436 11.7071L0.587252 6L6.29436 0.292893Z"
                                        fill="currentColor"></path>
                                </svg>
                                Manage collectible type
                            </Link>
                            <h2 className="mb-4 pt-2">Create single collectible</h2>
                            <div className="row mb-4">
                                <div className="col-lg-8 mb-3 mb-sm-0">
                                    <div className="mb-3">
                                        <label className="form-label CeraMed">Upload file</label>
                                        <div className="UploadFileAreaSmall Height GreyColor rounded mb-4">
                                            <div id="fileuploader">
                                                <div className="ajax-upload-dragdrop" style={{ verticalAlign: 'top', width: '100%' }}>
                                                    <div className="ajax-file-upload" style={{ position: 'relative', overflow: 'hidden', cursor: 'default' }}>
                                                        <p className="mb-2 CeraBold">PNG, GIF, WEBP, MP4 or MP3. Max 100mb.</p>
                                                        <form style={{ margin: '0px', padding: '0px' }}>
                                                            <input
                                                                onChange={onUploadFile}

                                                                type="file" accept="image/png, image/gif, image/jpeg, video/mp4" style={{ position: 'absolute', cursor: 'pointer', top: '0px', width: '100%', height: '100%', left: '0px', zIndex: '100', opacity: '0' }} />
                                                            <button onChange={onUploadFile} type="button" className="mb-0 btn BtnBlack rounded-pill">Choose File</button>
                                                        </form>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className="">
                                                {/* <label className="form-label CeraMed d-block mb-0">Put on marketplace</label> */}
                                                <small>Enter price to allow users instantly purchase your NFT</small>
                                            </div>
                                            {/* <div className="form-check form-switch">
                                                <input
                                                    //onChange={this.oc}
                                                    ame="isAvailableForMarket" className="form-check-input shadow-none cursor-pointer" type="checkbox"
                                                    id="putOnMarket"
                                                // checked={isAvailableForMarket}
                                                />
                                            </div> */}
                                        </div>


                                        <React.Fragment>
                                            <label className="form-label CeraMed d-block mb-0">Price</label>
                                            <div className="input-group mb-3">
                                                <input
                                                    onChange={(e) => {
                                                        setData({ ...data, price: e.target.value })

                                                    }}
                                                    value={data.price}

                                                    name="price" type="number" className="form-control shadow-none"
                                                    placeholder="Enter price for one piece" />


                                                <span className="input-group-text nuc-currency-badge">
                                                    <img style={{ height: 28, marginRight: 8 }} src="images/nucoin.png" alt="NUC" />
                                                    <span className="fw-bold">NUC</span>
                                                </span>
                                            </div>

                                            <label className="form-label CeraMed d-block GreyColor mb-1">Service fee <span
                                                className="BlackColor CeraBold">0%</span></label>
                                            {/* <label className="form-label CeraMed d-block GreyColor mb-0">You will receive <span
                                                    className="BlackColor CeraBold">{parseFloat(this.state.data.price || 0) - (parseFloat(this.state.data.price || 0) * 0)} NST </span></label>
                                           */}

                                        </React.Fragment>

                                    </div>


                                    <div className="mb-3">
                                        <label className="form-label CeraMed d-block mb-1">Title</label>
                                        <input
                                            onChange={(e) => {
                                                setData({ ...data, title: e.target.value })

                                            }}
                                            value={data.title}

                                            name="title" type="text" className="form-control shadow-none mb-3"
                                            placeholder="e.g Redeemable T-shirt with logo" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label CeraMed d-block mb-1">Description</label>
                                        <textarea
                                            onChange={(e) => {
                                                setData({ ...data, description: e.target.value })

                                            }}
                                            value={data.description}
                                            name="description" rows="4" className="form-control shadow-none"
                                            placeholder="e.g. After purchasing you’ll be able to get the real T-Shirt"></textarea>
                                        <p className="form-text mb-0">With preserved line-breaks</p>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label CeraMed d-block mb-1">Royalties</label>
                                        <div className="input-group mb-3">
                                            <input
                                                onChange={(e) => {
                                                    setData({ ...data, royalties: e.target.value })

                                                }}
                                                value={data.royalties}

                                                name='royalties' type="number" className="form-control shadow-none" placeholder="10" />
                                            <span className="input-group-text border-0" id="basic-addon1">%</span>
                                        </div>
                                        <p className="form-text">Suggested: 0%, 10%, 20%, 30%. Maximum is 50%</p>
                                    </div>
                                    <div className="mb-3">
                                        <button
                                            onClick={() => { setShowAdvance(!showAdvance) }}
                                            name="showAdvance" type="button" className="btn BtnBorder w-100 py-2">
                                            {!showAdvance ? 'Show Advanced Settings' : 'Hide Advanced Settings'}
                                        </button>
                                    </div>
                                    <div className="mb-3">
                                        {
                                            showAdvance && (
                                                <React.Fragment>
                                                    <label className="form-label CeraMed d-block mb-1">Properties <small className="GreyColor">(Optional)</small></label>
                                                    <div className="row gx-2">
                                                        <div className="col-xl-6">
                                                            <input onChange={(e) => {
                                                                setData(prevState => ({
                                                                    ...prevState,
                                                                    properties: {
                                                                        ...prevState.properties,
                                                                        size: e.target.value
                                                                    }
                                                                }));
                                                            }} name="size" type="text" className="form-control shadow-none mb-3"
                                                                placeholder="e.g. Size" />
                                                        </div>
                                                        <div className="col-xl-6">
                                                            <input onChange={(e) => {
                                                                setData(prevState => ({
                                                                    ...prevState,
                                                                    properties: {
                                                                        ...prevState.properties,
                                                                        type: e.target.value
                                                                    }
                                                                }));
                                                            }} name="type" type="text" className="form-control shadow-none mb-3"
                                                                placeholder="e.g. M" />
                                                        </div>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label CeraMed d-block mb-1">Alternative text for
                                                            NFT<small className="GreyColor"> (Optional)</small></label>
                                                        <textarea
                                                            onChange={(e) => {
                                                                setData({ ...data, alternativeText: e.target.value })
                                                            }}

                                                            name="alternativeText" rows="4" className="form-control shadow-none"
                                                            placeholder="Image description in details (do not start with word “image”)"></textarea>
                                                        <p className="form-text mb-0">Text that will be used in VoiceOver for people
                                                            with disabilities</p>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }

                                        {Object.keys(errors).length > 0 && (
                                            <div className="alert alert-danger" role="alert">
                                                {errors[Object.keys(errors)[0]]}
                                            </div>
                                        )}


                                        {/* {
                                                this.state.isError && this.state.message && (
                                                    <div className="alert alert-danger" role="alert">
                                                        {this.state.message}
                                                    </div>
                                                )
                                            }
                                            {
                                                !this.state.isError && this.state.message && (
                                                    <div className="alert alert-success" role="alert">
                                                        {this.state.message}
                                                    </div>
                                                )
                                            } */}
                                        <div className="row justify-content-between align-items-center">
                                            <div className="col-md-auto mb-3 mb-md-0">
                                                {/* || this.state.balance < 0.1 */}
                                                <button
                                                    // disabled={this.state.isLoading} 
                                                    onClick={createNft}

                                                    type="button" className="btn BtnBlack py-2 px-5">Create item</button>


                                            </div>

                                            {/* {this.state.balance !== null && this.state.balance < 0.1 && <label className="BlueColor">Balance is too low to make transaction. Balance: {this.state.balance}</label>}
                                            */}


                                        </div>

                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="PreviewBoxSticky">
                                        <label className="form-label CeraMed">Preview</label>
                                        <div className="PreviewBox premium-simple-preview">
                                            {
                                                !imgSrc ? (
                                                    <div className="placeholder-content">
                                                        {/* <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#CBD5E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M17 8L12 3L7 8" stroke="#CBD5E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M12 3V15" stroke="#CBD5E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg> */}
                                                        <span>Upload file to preview</span>
                                                    </div>
                                                ) : !isVideo(data.uploadType) ? (
                                                    <img className="preview-media-full" src={imgSrc} alt="NFT Preview" />
                                                ) : (
                                                    <video autoPlay className="preview-media-full" loop muted>
                                                        <source src={imgSrc} type="video/mp4" />
                                                    </video>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <MnemonicsConfirmationModal
                visible={mnemonicsConfirmationModal}
                currentUser={currentUser}
                onClose={() => setShowMnemonicsConfirmationModal(false)}
                onConfirm={(data) => {
                    handleMintNft(data.mnemonics, data.publicAddress, data.saveMyMnemonics, data.mnemonicsPwd)
                    setShowMnemonicsConfirmationModal(false);
                }}
            ></MnemonicsConfirmationModal>


            <NFTStepsModal
                visible={stepModal}
                step={creationStep}
                isLoading={loader}
                isError={isError}
                messageList={messageList}
                orderHash={orderHash}
                onClose={(value) => {
                    if (typeof value === "boolean" && value === true) {
                        resetState();
                    }
                    setShowStepModal(false);
                    setCreationStep(0);
                    setIsError("");
                    setMessageList([]);
                }}
            />
            <ContinueWithPassword
                visible={passwordModal}
                currentUser={currentUser}
                cypherSecret={cypherSecret}
                onClose={() => setShowPasswordModal(false)}
                onConfirm={(data) => {
                   
                    if (data.forgotPassword) {
                        setShowPasswordModal(false)
                        setShowMnemonicsConfirmationModal(true);
                    }
                    else {
                        handleMintNft(data.mnemonics, data.publicAddress)
                        setShowPasswordModal(false)

                    }

                }}

            >

            </ContinueWithPassword>
            <MissingMnemonics visible={missMnemonicsModal} onClose={() => setMissMnemonicsModal(false)} />
        </main>


    );
};

export default SingleNFT;
